export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

export function vehicleSuffix4(value) {
  const digits = digitsOnly(value);
  return digits.length >= 4 ? digits.slice(-4) : "";
}

export function chassisSuffix6(value) {
  const normalized = String(value || "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
  return normalized.length >= 6 ? normalized.slice(-6) : "";
}

export function lowerTrim(value) {
  return String(value || "")
    .trim()
    .toLowerCase();
}

export function recordSource(item) {
  if (item?.sourceType === "linked_banker" || item?.source === "bank_record") {
    return "bank";
  }
  return "agency";
}

export function toStoredVehicle(item) {
  const payload = { ...item, uploadedBy: undefined };
  delete payload.uploadedBy;
  const id = String(item?._id || item?.id || "").trim();
  return {
    id,
    source: recordSource(item),
    updatedAt: item?.updatedAt || "",
    vehicleSuffix4: vehicleSuffix4(item?.vehicleNumber),
    chassisSuffix6: chassisSuffix6(item?.chassisNumber),
    customerNameLower: lowerTrim(item?.customerName),
    loanLower: lowerTrim(item?.loanAccountNumber),
    payload,
  };
}
